/* Copyright (c) 2017 Backpack Health LLC */
/* eslint-disable no-param-reassign */
import * as _ from 'lodash';

import { isValidNumberOrRange } from '../../utilities/Validators';
import { medliTermConversions } from './medliTerm';


function amount(healthEntryState, languageCode) {
  healthEntryState.amount = healthEntryState.amount || { term: { id: null }, value: '' };
  let compositeUnit = null;
  let compositeTerm = null;

  return {
    get: () => healthEntryState.amount,
    set: (amountData) => { healthEntryState.amount = amountData; },
    hasAmount: () => !!healthEntryState.amount.value,
    replaceWithSearchTerm: (medliSearchTerm) => {
      healthEntryState.amount.term = medliTermConversions.convertSearchTermToTerm(medliSearchTerm, languageCode);
    },
    formattedTermName: (forceLanguageCode) => {
      const code = forceLanguageCode || languageCode;
      return _.get(healthEntryState.amount, 'term.strings', {})[code];
    },
    formattedCompositeTermName: (forceLanguageCode) => {
      const code = forceLanguageCode || languageCode;
      return _.get(compositeTerm, 'strings', {})[code];
    },
    formattedAmount: (forceLanguageCode) => {
      if (compositeTerm) {
        const pairs = this.amount.getValueUnitPairs();
        return _.compact([
          pairs[0].value && `${pairs[0].value} ${this.amount.formattedTermName(forceLanguageCode)}`,
          pairs[1].value && `${pairs[1].value} ${this.amount.formattedCompositeTermName(forceLanguageCode)}`,
        ]).join(' ');
      } else {
        return `${this.amount.getValue()} ${this.amount.formattedTermName(forceLanguageCode)}`;
      }
    },
    clear: () => {
      healthEntryState.amount = { term: { id: null }, value: '' };
      compositeUnit = null;
      compositeTerm = null;
    },
    isInvalid: () => !isValidNumberOrRange(healthEntryState.amount.value.replace('|', '')),

    setUnit: (unitData) => {
      let baseUnit = unitData;
      if (unitData.composite_term) {
        compositeTerm = unitData.composite_term;
        baseUnit = unitData;
        compositeUnit = unitData;
      }
      healthEntryState.amount.term = baseUnit;
    },
    getUnit: () => healthEntryState.amount.term,
    hasUnit: () => !!(healthEntryState.amount.term && healthEntryState.amount.term.id),

    setValue: (value) => { healthEntryState.amount.value = value; },
    getValue: () => healthEntryState.amount.value,
    getValueUnitPairs: () => {
      let values = [];
      if (!compositeUnit) {
        values = [healthEntryState.amount.value];
      } else {
        values = healthEntryState.amount.value.split(compositeUnit.delimiter);
        while (values.length < 2) {
          values.push('');
        }
      }

      const unitPairs = [{
        value: values[0],
        unit: healthEntryState.amount.term,
      }];

      if (compositeTerm) {
        unitPairs.push({
          value: values[1],
          unit: compositeTerm,
        });
      }

      return unitPairs;
    },
    getValueArray: () => {
      if (!compositeUnit) { return [healthEntryState.amount.value]; }

      const values = healthEntryState.amount.value.split(compositeUnit.delimiter);
      while (values.length < 2) {
        values.push('');
      }
      return values;
    },
    forceValueForUnit: () => {
      if (!compositeUnit) {
        healthEntryState.amount.value = healthEntryState.amount.value.split('|')[0];
      }
    },
    setValues: (values) => {
      if (compositeUnit) {
        healthEntryState.amount.value = values.join(compositeUnit.delimiter);
      } else {
        healthEntryState.amount.value = _.compact(values).join('');
      }
    },
  };
}


export function cleanAmount(healthEntryCategoryState) {
  const amountId = _.get(healthEntryCategoryState, 'amount.term.id', '');
  const amountValue = _.get(healthEntryCategoryState, 'amount.value', '');
  if (amountId === '' || amountId === null || amountValue === '' || amountValue === null) {
    healthEntryCategoryState = _.omit(healthEntryCategoryState, ['amount']);
  }

  return healthEntryCategoryState;
}

export default amount;
